import React,{useEffect, useState} from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import Select from "react-select";
import { useLogout } from "../Utils/auth";
import { UseApi } from "../Api/UseApi";
import { useAppContext } from "../AppProvider/AppProvider";
import classNames from "classnames";

export default function Layout() {
  const logout = useLogout();
  const location = useLocation();
  const currentPath = location.pathname;
  const { loggedIn, setLoggedIn, user, setUser, useIAP, clientClassName, setClientClassName } = useAppContext();
  const [navLinks, setNavLinks] = useState([]);
  const [multiClassNames, setMultiClassNames] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  const { fetchApi, loading: apiLoading, error: apiError } = UseApi();

  const adminNavLinks = [
    { to: "/", label: "Inicio" },
    { to: "/admin/users", label: "Usuarios" },
    { to: "/form-builder", label: "Generador de formularios" },
    { to: "/edit-form", label: "Editar formulario" },
    { to: "/new-records", label: "Crear registro" },
    { to: "/records", label: "Ver registros" },
    { to: "/clients", label: "Clientes" },
    { to: "/projects", label: "Proyectos" },
    { to: "/styles", label: "Estilos" },
  ];

  const userNavLinks = [
    { to: "/", label: "Inicio" },
    { to: "/new-records", label: "Crear registro" },
    { to: "/records", label: "Ver registros" }
  ];

  const handleLogout = () => {
    logout();
    setClientClassName("");
    setSelectedOption(null);
    setLoggedIn(false);
    window.location.reload();
  }

  const getClient = async (client_id) => {
    try {
      const params = client_id ? `?client_id=${client_id}` : '';
      const data = await fetchApi(`/api/clients${params}`);

      if (!Array.isArray(data) && data?.class_name) {
        setClientClassName(data.class_name);
      }
      if (Array.isArray(data)) {
        const customOptions = []
        data.map((item, index, array) => {
          if (item?.class_name && item?.name) {
            customOptions.push({value:item.class_name, label:item.name});
          }
        });
        setMultiClassNames(customOptions);
        setClientClassName(data.class_name);
      }
    } catch (error) {
      console.error("Error al cargar cliente:", error);
    }
  };

  useEffect(() => {
    if (user?.assigned_clients?.length == 1) {
      getClient(user.assigned_clients[0]);
    }

    if (user?.role == 'admin' && user?.assigned_clients?.length > 1) {
      getClient();
    }

    if (user.role == "admin") {
      setNavLinks(adminNavLinks);
    }

    if (user.role == "user") {
      setNavLinks(userNavLinks);
    }
  }, [user,location]);

  const handleChange = (selected) => {
    if (selected && selected?.value !== '') {
      setSelectedOption(selected);
    }
  };

  useEffect(() => {
    if (selectedOption && selectedOption?.value !== '') {
      setClientClassName(selectedOption.value);
      localStorage.setItem("clientClassName", JSON.stringify(selectedOption));
    } else {
      let localClassName = localStorage.getItem("clientClassName");
      if(localClassName) {
        localClassName = JSON.parse(localClassName);
        setClientClassName(localClassName.value);
        setSelectedOption(localClassName);
      }
    }
  }, [clientClassName, selectedOption]);

  const currentDate = new Date();
  const fullYear = currentDate.getFullYear();

  return (
    <div className={classNames("min-h-screen flex flex-col bg-white text-gray-900", {[clientClassName]:clientClassName})}>
      <header className="bg-white p-4 flex justify-between items-center border-b border-gray-300">
        <div className="container mx-auto flex justify-between items-center">
          {loggedIn ? (
            <>
              <nav className="space-x-6">
                {navLinks.map(({ to, label }) => {
                  const isActive = currentPath === to;
                  return (
                    <Link
                      key={to}
                      to={to}
                      className={isActive ? "text-black font-bold" : "text-gray-600 hover:text-black"}
                    >
                      {label}
                    </Link>
                  );
                })}
              </nav>
              <div className="flex gap-3 items-center">
                {!false &&
                  <button
                      onClick={handleLogout}
                      className="bg-black hover:bg-gray-900 text-white px-4 py-2 rounded transition-colors duration-200"
                    >
                      Cerrar sesión
                  </button>
                }
                {user?.email && <span className="text-gray-600">{user.email}</span>}
                {
                  multiClassNames?.length > 1 &&
                  <div>
                    <Select
                      value={selectedOption}
                      placeholder="Styles"
                      options={multiClassNames}
                      onChange={handleChange} />
                  </div>
                }
              </div>
            </>
          )
          :
          <div>
            <h2>Login</h2>
          </div>
          }
        </div>
      </header>

      <main className="flex-grow container mx-auto p-6 bg-white">
        <Outlet/>
      </main>

      <footer className="bg-white border-t border-gray-300 text-center p-4 text-xs text-gray-500">
        © {fullYear} Babilonia
      </footer>
    </div>
  );
}
